"use strict";

(function ($) {
  $("document").ready(function () {
    let counter = 0;
    $(".contrast-js").on("click", function () {
      switch (counter) {
        case 0:
          $("body").addClass("contrast-grey-active");
          localStorage.setItem("contrast-active", "contrast-grey-active");
          break;
        case 1:
          localStorage.removeItem("contrast-active", "contrast-grey-active");
          $("body").removeClass("contrast-grey-active");

          $("body").addClass("contrast-black-yellow-active");
          localStorage.setItem(
            "contrast-active",
            "contrast-black-yellow-active",
          );
          break;
        case 2:
          localStorage.removeItem(
            "contrast-active",
            "contrast-black-yellow-active",
          );
          $("body").removeClass("contrast-black-yellow-active");

          $("body").addClass("contrast-yellow-black-active");
          localStorage.setItem(
            "contrast-active",
            "contrast-yellow-black-active",
          );
          break;
        default:
          localStorage.removeItem(
            "contrast-active",
            "contrast-yellow-black-active",
          );
          $("body").removeClass("contrast-yellow-black-active");
      }
      if (counter == 3) {
        counter = 0;
      } else {
        counter++;
      }
    });

    function change_contrast() {
      let get_change_contrast = localStorage.getItem("contrast-active");
      if (get_change_contrast) {
        $("body").addClass(get_change_contrast);
      }
    }
    change_contrast();

    setTimeout(function () {
      $(".mce-edit-area iframe").each(function () {
        if ($("body").hasClass("contrast-grey-active")) {
          $(this.contentDocument).find("body").addClass("contrast-grey-active");
        }
      });
      $(".mce-edit-area iframe").each(function () {
        if ($("body").hasClass("contrast-black-yellow-active")) {
          $(this.contentDocument).find("body").addClass(
            "contrast-black-yellow-active",
          );
        }
      });
      $(".mce-edit-area iframe").each(function () {
        if ($("body").hasClass("contrast-yellow-black-active")) {
          $(this.contentDocument).find("body").addClass(
            "contrast-yellow-black-active",
          );
        }
      });
    }, 500);
  });
})(jQuery);
